const STATS: ReadonlyArray<{ value: string; label: string }> = [
  { value: '5 200+', label: 'commerçants actifs' },
  { value: '14', label: 'pays d’Afrique' },
  { value: '2,3 M', label: 'tickets / mois' },
  { value: '99,8 %', label: 'uptime sync' },
];

export default function TrustStripV2() {
  return (
    <section className="border-y-2 border-charcoal-800 bg-charcoal-950 py-12 md:py-16">
      <div className="mx-auto max-w-7xl px-6 md:px-8">
        <ul className="grid grid-cols-2 gap-x-6 gap-y-10 md:grid-cols-4">
          {STATS.map((s) => (
            <li key={s.label} className="text-center md:text-left">
              <div className="font-marketing-display text-[clamp(36px,4.5vw,56px)] font-bold leading-none tracking-[-0.03em] text-lime-400">
                {s.value}
              </div>
              <div className="mt-2 font-marketing-mono text-[11px] font-medium uppercase tracking-[0.14em] text-charcoal-200">
                {s.label}
              </div>
            </li>
          ))}
        </ul>
      </div>
    </section>
  );
}
